import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import Version from '../../components/Ticket/Version/VersionDetail';
export default class VersionDetailPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <Version />
            </div>
        )
    }
}
